export const COUNTRIES_FEATURE_KEY = 'dictionary-countries';
export const VOIVODESHIP_FEATURE_KEY = 'dictionary-voivodeship';
